module.exports = __webpack_public_path__ + "static/img/miyazawa_03.3198d0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/miyazawa_03.png
// module id = 0PMN
// module chunks = 0